<script setup>
import useStaff from "~/modules/staff";

const route = useRoute();

const head = computed(() => {
  return {
    title: "РУСДРАМ",
    meta: [
      {
        hid: "title",
        property: "title",
        content: "РУСДРАМ",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: "РУСДРАМ",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Сотрудники | Государственный русский театр драмы им. Ф. А. Искандера",
      },
      {
        hid: "og:description",
        property: "og:description",
        content:
          "Сотрудники | Государственный русский театр драмы им. Ф. А. Искандера",
      },
      {
        hid: "url",
        name: "url",
        content: `https://rusdram.org${route.fullPath}`,
      },
      {
        hid: "og:url",
        property: "og:url",
        content: `https://rusdram.org${route.fullPath}`,
      },
      {
        hid: "image",
        name: "image",
        content: "https://rusdram.org/rusdram.jpg",
      },
      {
        name: "og:image",
        property: "og:image",
        content: "https://rusdram.org/rusdram.jpg",
      },
    ],
  };
});

useHead(head);

const { getLeadership, getInvitedStaff, getStaff } = useStaff();

const { data: state, pending: isLoaded } = await useAsyncData(
  "getLeadership",
  async () => {
    const leadership = await getLeadership();
    const staff = await getInvitedStaff();
    const invited = await getStaff();

    return {
      leadership,
      staff,
      invited,
    };
  }
);
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <div v-if="state">
        <r-section title="Руководство">
          <div
            class="grid grid-rows-2 lg:grid-rows-1 grid-cols-4 lg:grid-cols-11 gap-7"
          >
            <template
              v-for="(person, index) in state.leadership"
              :key="person._id"
            >
              <RTroupeCart
                :person="person"
                v-if="person.sortKey != 0"
                :class="[
                  index === 0 ? `` : ``,
                  index === 0
                    ? `col-start-2 lg:col-start-${index * 3 + 2}`
                    : `col-start-${index * 2 - 1} lg:col-start-${
                        index * 3 + 2
                      }`,
                  index === 0
                    ? `col-end-4 lg:col-end-${index * 3 + 5}`
                    : `col-end-${index * 2 + 1} lg:col-end-${index * 3 + 5}`,
                ]"
              ></RTroupeCart>
            </template>
          </div>
        </r-section>
        <r-section title="Сотрудники">
          <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-7 gap-y-10">
            <template v-for="person in state.invited" :key="person._id">
              <RTroupeCart
                :person="person"
                type="medium"
                v-if="person.sortKey != 0"
              ></RTroupeCart>
            </template>
          </div>
        </r-section>
        <r-section title="Приглашенные специалисты">
          <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-7 gap-y-10">
            <template v-for="person in state.staff" :key="person._id">
              <RTroupeCart
                :person="person"
                type="small"
                v-if="person.sortKey != 0"
              ></RTroupeCart>
            </template>
          </div>
        </r-section>
      </div>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
